module.exports = __webpack_public_path__ + "resources/img/img_hi_psm_m.56439baa4d0d7567d9d1e6642b746a5e.png";